import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const MarkdownStyles = styled.div`
  p {
    margin-bottom: 30px;
    word-break: break-word;
    img {
      padding-top: 25px;
      padding-bottom: 0;
    }
  }

  p + br {
    display: none;
  }

  img {
    width: 100%;
  }
  a {
    color: ${Colors.primary.claytonBlue.standard};
  }
  ul,
  ol {
    li {
      color: ${Colors.grayscaleCoolGray08};
      font-family: 'source-sans-pro', sans-serif;
      line-height: 1.69;
      letter-spacing: -0.3px;
      position: relative;
      width: 100%;
      list-style-position: inside;
      text-indent: -1em;
      padding-left: 1em;
    }
    margin-bottom: 20px;
    margin-top: 15px;
  }
  ul {
    margin-left: 30px;
    list-style-type: none;

    li {
      &:before {
        color: ${Colors.primaryClaytonBlue};
        content: '\\2022';
        font-family: 'source-sans-pro', sans-serif;
        font-size: 19px;
        margin-right: 13px;
        margin-top: -2px;
      }
    }
  }
`;
